import React from 'react';
import ReactDOM from 'react-dom/client';

import { Main } from './main';

const root = ReactDOM.createRoot(document.getElementById('root')!);

root.render(<Main />);
